import React from "react";
import { PageContainer } from "@/components/ui/PageContainer";
import { cn } from "@/lib/utils";

export type ContentLayoutProps = {
  children: React.ReactNode;
  center?: boolean;
  className?: string;
  maxWidthClassName?: string;
  withVerticalPadding?: boolean;
};

export const ContentLayout: React.FC<ContentLayoutProps> = ({
  children,
  center = true,
  className,
  maxWidthClassName = "max-w-[960px]",
  withVerticalPadding = false,
}) => {
  const [printUrl, setPrintUrl] = React.useState("");
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      setPrintUrl(window.location.href);
    }
  }, []);
  return (
    <main>
      <PageContainer
        center={center}
        maxWidthClassName={maxWidthClassName}
        withVerticalPadding={withVerticalPadding}
      >
        <div className={cn("content", className)}>{children}</div>
      </PageContainer>
      <div className="print-footer print-only">
        <span className="url">{printUrl}</span>
        <span className="page" />
      </div>
    </main>
  );
};

export default ContentLayout;
